import React, { Component, Fragment } from "react";
import { withGetScreen } from "react-getscreen";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Pill from "../../../../shared/Pill/Pill";
import { getAllSales, handleChangeFilterStatements } from "../../../actions/sales";
import { MODALITY } from "../consts";

class SalePaymentModalityTab extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modalities: [
				{
					value: MODALITY.ALL,
					label: "Todas"
				},
				{
					value: MODALITY.CONVENTIONAL,
					label: "Convencional"
				},
				{
					value: MODALITY.SCHEDULED,
					label: "Agendado"
				}
			],
			selectSelected: this.props.modality || MODALITY.ALL
		};
	}

	handleModalityChange(modality) {
		this.setState({
			selectSelected: modality
		});

		if (!this.props.isFetching) {
			modality = this.props.filteredStatements.modality === modality ? MODALITY.ALL : modality;
			this.props.handleChangeFilterStatements(this.props.filteredStatements, { modality }, true);
		}
	}

	render() {
		return (
			<div className="sale-payment-status-container">
				{this.props.isFetching}

				{this.props.isMobile() ? null : (
					<Fragment>
						<span>Modalidade</span>
						<nav className="sale-payment-status-tab">
							{this.state.modalities.map(modality => {
								return (
									<Pill
										onClick={() => this.handleModalityChange(modality.value)}
										className={`tab-received${
											this.props.isFetching ? " tab-received--disabled" : ""
										}`}
										selected={this.props.filteredStatements.modality === modality.value}
									>
										{modality.label}
									</Pill>
								);
							})}
						</nav>
					</Fragment>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	filteredStatements: state.mySales.filteredStatements,
	isFetching: state.mySales.isFetching
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			handleChangeFilterStatements,
			getAllSales
		},
		dispatch
	);
export default connect(mapStateToProps, mapDispatchToProps)(withGetScreen(SalePaymentModalityTab));
